import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../Common/Configurations/APIConfig";
import axios from 'axios';
import moment from "moment";
export default function BrokerHeader() {
    const navigate = useNavigate();
    const [values, setValues] = useState({})
    function CheckExpirationTime() {
        if (localStorage.getItem('tokenexpiration') !== "") {
            const expiredate = new Date(localStorage.getItem('tokenexpiration'));
            const localdate = new Date();
            if (expiredate > localdate) {
                return true;
            }
        }
        return false;
    }
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const GetUserData = () => {
        axios.get(config.APIACTIVATEURL + config.GETUSER + "?Id=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setValues(response.data.data);
                    setValues(response.data.data);
                    localStorage.setItem("userName", response.data.data.name);
                }
                else {
                    setValues({});
                }
            });
    }
    useEffect(() => {
        const token = localStorage.getItem('userToken');
        const role = localStorage.getItem('roleName');
        if (!token || !CheckExpirationTime() || role !== 'BROKER') {
            navigate('/login');
            return;
        }
        GetUserData();
    }, [])
    return (
        <header id="page-topbar">
            <div className="layout-width">
                <div className="navbar-header">
                    <div className="d-flex">
                        {/* LOGO */}
                        <div className="navbar-brand-box horizontal-logo">
                            <Link className="logo logo-dark">
                                <span className="logo-sm">
                                    <div>
                                        <img src="/assets/images/logo3d.jpg" style={{ maxHeight: "60px" }}></img>
                                    </div>
                                </span>
                                <span className="logo-lg">
                                    <div>
                                        <img src="/assets/images/logo3d.jpg" style={{ maxHeight: "60px" }}></img>
                                    </div>
                                </span>
                            </Link>
                            <Link className="logo logo-light">
                                <span className="logo-sm">
                                    <div>
                                        <img src="/assets/images/logo3d.jpg" style={{ maxHeight: "60px" }}></img>
                                    </div>
                                </span>
                                <span className="logo-lg">
                                    <div>
                                        <img src="/assets/images/logo3d.jpg" style={{ maxHeight: "60px" }}></img>
                                    </div>
                                </span>
                            </Link>
                        </div>
                        <button type="button" className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon"></button>
                    </div>
                    <div className="d-flex align-items-center">
                        <div className="dropdown header-item">
                            {
                            localStorage.getItem("roleName") === "BROKER" ?
                                    <span className="d-flex align-items-center p-2">
                                        {values?.subscriptionName === "BrokerSync 360 3 Day Trail" ?
                                            <>
                                                <span className="text-start ms-xl-2">
                                                    <span className="d-none d-xl-inline-block fs-1 badge bg-success mr-2">Current Plan : {values?.subscriptionName}</span>
                                                    <span className="me-2 d-none d-xl-inline-block fs-1 badge bg-danger">Ends on {moment(values.endDate).format("DD MMM YYYY")}</span>
                                                </span>
                                            </>
                                            :
                                            <>
                                                <span className="text-start ms-xl-2">
                                                    <span className="me-2 d-none d-xl-inline-block fs-12 badge bg-success">Available Credits : {values.availableCredits}</span>
                                                </span>
                                            </>
                                        }
                                    </span>
                                    : ""}
                        </div>
                        <div className="dropdown ms-sm-3 header-item topbar-user">
                            <button type="button" className="btn shadow-none" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="d-flex align-items-center">
                                    <img className="rounded-circle header-profile-user" src="/assets/images/user.png" alt="Header Avatar" />
                                    <span className="text-start ms-xl-2">
                                        <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{values?.name}</span>
                                        <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">Welcome</span>
                                    </span>
                                </span>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end">
                                {/* item*/}
                                <h6 className="dropdown-header">Welcome!</h6>
                                <Link className="dropdown-item" to={"/logout"}><i className="mdi mdi-logout text-muted fs-4 align-middle me-1" /> <span className="align-middle" data-key="t-logout">Logout</span></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

    );
}